export { default as Img200 } from './processed/200/BlackHawkDown.jpg';
export { default as Img400 } from './processed/400/BlackHawkDown.jpg';
export { default as Imgthumb } from './processed/thumb/BlackHawkDown.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/BlackHawkDown.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/BlackHawkDown.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      251,
      216,
      29
    ],
    "_population": 233,
    "_hsl": [
      0.1403903903903904,
      0.9652173913043478,
      0.5490196078431372
    ]
  },
  "LightVibrant": {
    "_rgb": [
      250,
      224,
      105
    ],
    "_population": 903,
    "_hsl": [
      0.1367816091954023,
      0.935483870967742,
      0.696078431372549
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      109,
      26,
      17
    ],
    "_population": 269,
    "_hsl": [
      0.016304347826086956,
      0.7301587301587302,
      0.24705882352941175
    ]
  },
  "Muted": {
    "_rgb": [
      144,
      141,
      116
    ],
    "_population": 6,
    "_hsl": [
      0.14880952380952386,
      0.11199999999999999,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      200,
      180,
      148
    ],
    "_population": 4,
    "_hsl": [
      0.10256410256410259,
      0.3209876543209875,
      0.6823529411764706
    ]
  },
  "DarkMuted": {
    "_rgb": [
      77,
      81,
      51
    ],
    "_population": 142,
    "_hsl": [
      0.18888888888888888,
      0.22727272727272724,
      0.2588235294117647
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/BlackHawkDown.js